"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Permissions/MobileGenericGuide.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

const MobileGenericGuide = () => (
  _react2.default.createElement('div', { className: "meeting--perms-guide--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 4}}
    , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 5}}, "You haven't allowed access to your microphone and camera. Please check your browser settings and allow access to continue."

    )
  )
)

exports. default = MobileGenericGuide
